import Vue from "vue";

export const getNewsDetails = ({ dispatch }, id) => {
  Vue.http.get("api/v1/News" + "/" + id).then(function (response) {
    dispatch("NEWS_DETAILS_LOADED", response.data);
  });
};




// WEBPACK FOOTER //
// ./src/views/news/NewsActions.js